<template>
    <div class="login-container">


        <el-form autoComplete="on"
                 :model="loginForm"
                 size="default"
                 :rules="loginRules"
                 ref="loginForm"
                 class="card-box login-form">

            <h3 class="title">忘记密码</h3>


            <el-form-item prop="newPass1">
                <el-input name="newPass1"
                          type="text"
                          v-model="loginForm.newPass1"
                          autoComplete="off"
                          placeholder="新密码"
                />
            </el-form-item>

            <el-form-item prop="newPass2">
                <el-input name="newPass2"
                          type="text"
                          v-model="loginForm.newPass2"
                          autoComplete="off"
                          placeholder="确认密码"
                />
            </el-form-item>

            <el-form-item prop="mobile">
                <el-input name="mobile" type="text" v-model="loginForm.mobile"
                          autoComplete="on" placeholder="为了确保是您本人操作,请验证手机号"/>
            </el-form-item>

            <el-row :gutter="10">
                <el-col :span="12">
                    <el-form-item prop="code">
                        <el-input placeholder="请输入验证码" v-model="loginForm.code"></el-input>
                    </el-form-item>
                </el-col>

                <el-col :span="12">
                    <el-form-item>
            <span v-show="show" @click="getCode">
              <el-button type="primary" style="width: 100%" @click="mobileCode">获取验证码</el-button>
            </span>
                        <span v-show="!show" class="count">
              <el-button type="primary" style="width: 100%">{{ count }} s</el-button>
            </span>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="10">
                <el-col :span="12">
                    <el-form-item>
                        <el-button type="primary" style="width: 100%" @click="upPassByCode">
                            确定
                        </el-button>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item>
                        <el-button type="primary" style="width: 100%" @click="gotoback">
                            返回登录
                        </el-button>
                    </el-form-item>
                </el-col>
            </el-row>


            <div class="tips">Copyright © {{ new Date().getFullYear() }} {{ $store.state.sys.company }}</div>
        </el-form>
    </div>
</template>

<script>

import authApi from "@/api/auth";

export default {

    data() {
        let checkPwd2 = ((rule, value, callback) => {
            if (value.trim().length == 0) {
                callback(new Error("请确认密码不能为空"));
            } else if (value != this.loginForm.newPass1) {
                callback(new Error("2次密码不一致"));
            } else {
                callback();
            }
        })
        return {
            show: true,
            count: '发送验证码',
            timer: null,

            loginForm: {
                mobile: "",
                code: "",
                newPass2: "",
                newPass1: ""
            },

            loginRules: {
                mobile: [
                    {required: true, message: "请输入手机号"},
                    {required: true, message: "手机号格错误", pattern: /^1[0-9][0-9]{9}$/}
                ],
                code: [
                    {required: true, message: "请输入验证码"}
                ],
                newPass1: [
                    {required: true, message: '请填写新的密码'},
                    {min: 6, max: 12, trigger: 'blur', message: '密码长度为6到12位'},
                    {
                        validator: (rule, value, callback) => {
                            if (!/(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9]).{6,12}/.test(value)) {
                                callback(new Error('密码需包含字母数字和特殊符号！'))
                            } else {
                                callback()
                            }
                        }
                    }
                ],
                newPass2: [
                    {required: true, message: "两次密码不一样", validator: checkPwd2}
                ]
            }
        };
    },

    methods: {
        getCode() {

        },

        mobileCode() {
            //判断手机号填写是否正确
            let reg = /^1[3|4|5|7|8][0-9]{9}$/
            let flag = reg.test(this.loginForm.mobile)
            if (!flag) {
                this.$message({
                    message: '手机号格式错误',
                    type: 'error'
                });
                return;
            }
            authApi.mobileCode(this.loginForm).then(res => {
                this.$message.success(res.message)
                if (res.code == 0) {
                    const TIME_COUNT = 60;
                    if (!this.timer) {
                        this.count = TIME_COUNT;
                        this.show = false;
                        this.timer = setInterval(() => {
                            if (this.count > 0 && this.count <= TIME_COUNT) {
                                this.count--;
                            } else {
                                this.show = true;
                                clearInterval(this.timer);
                                this.timer = null;
                            }
                        }, 1000)
                    }
                }
            })
        },
        gotoback() {
            this.$router.push('/');
        },
        upPassByCode() {
            this.$refs.loginForm.validate((valid) => {
                if (valid) {
                    authApi.upPassByCode(this.loginForm).then(res => {
                        if (res.code == 0){
                            this.$message.success("修改成功，请重新登录")
                            this.$router.push('/');
                        }else {
                            this.$message.success(res.message)
                        }
                    })
                }
            })
        }

    }


};
</script>

<style lang="less">
@bg: #2d3a4b;
@dark_gray: #889aa4;
@light_gray: #eee;
.login-container {
    position: fixed;
    height: 100%;
    width: 100%;
    background-image: linear-gradient(135deg, #184e68, #57ca85);

    input:-webkit-autofill {
        -webkit-box-shadow: 0 0 0px 1000px #293444 inset !important;
        -webkit-text-fill-color: #fff !important;
    }

    input {
        background: transparent;
        border: 0px;
        -webkit-appearance: none;
        border-radius: 0px;
        padding: 12px 5px 12px 15px;
        color: @light_gray;
        height: 47px;
    }

    .el-input {
        display: inline-block;
        height: 47px;
        width: 85%;
    }

    .tips {
        font-size: 14px;
        color: @light_gray;
        margin-bottom: 10px;
        text-align: center;
    }

    .svg-container {
        padding: 6px 5px 6px 15px;
        color: @dark_gray;
        vertical-align: middle;
        width: 30px;
        display: inline-block;

        &_login {
            font-size: 20px;
        }
    }

    .title {
        font-size: 26px;
        font-weight: 400;
        color: @light_gray;
        margin: 0px auto 40px auto;
        text-align: center;
        font-weight: bold;
    }

    .login-form {
        position: absolute;
        left: 0;
        right: 0;
        max-width: 400px;
        padding: 35px 35px 15px 35px;
        margin: 120px auto;
    }

    .el-form-item {
        border: 1px solid rgba(255, 255, 255, 0.1);
        background: rgba(0, 0, 0, 0.1);
        border-radius: 5px;
        color: #454545;
        margin-bottom: 22px;
    }

    .el-form-item__error {
        padding-top: 4px;
    }

    .show-pwd {
        position: absolute;
        right: 10px;
        top: 7px;
        font-size: 16px;
        color: @dark_gray;
        cursor: pointer;
        user-select: none;
    }

    .thirdparty-button {
        position: absolute;
        right: 35px;
        bottom: 28px;
    }
}
</style>
